<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div>
  	<headlink></headlink>
    <div class="hello">
    <!--<header class="header ui-header-positive ui-border-b" style="padding:0 210px">
      <ul class="ui-tiled">
        <div><img src="/static/img/logo.png" /> </div>
        <router-link to="/devicemanage" tag="li" class="active" ><div>设备控制</div></router-link>
        <router-link to="/addDevice" tag="li"><div>添加设备</div></router-link>
        <router-link to="/userManage" tag="li"><div>用户管理</div></router-link>
        <router-link to="/msgLog" tag="li"><div>消息记录</div></router-link>
        <router-link to="/send" tag="li"><div>指令群发</div></router-link>
        <router-link to="/baidu" tag="li"><div>百度地图</div></router-link>
        <router-link to="/info" tag="li"><div>个人信息</div></router-link>
        
         
        <li v-on:click="logOut()"><div  >退出</div></li>
      </ul>
    </header>-->
 
    <div class="container ui-flex ui-flex-pack-center">
        	<div class="right-container ui-center " >
        		<div class="head-top" >
	        		设置报警时长<input v-model="msgTime"  />秒  <button class="pointer" v-on:click="setTime()">确&nbsp;定</button>
	        	</div>
        		<ul class="ui-row li-height1 img" v-for="log in logList" >
        			<li class="ui-col ui-col-10 ui-border-b icon-image" ><img width="45px" v-bind:src="[log.msgType == 1?'/static/img/icon5.png':'/static/img/icon14.png']" /></li>
							<li class="ui-col ui-col-90 left-padding ui-border-b li">{{log.msgName}}</li>
    					<li class="ui-col ui-col-10 icon-image ui-border-b li" ></li>
							<li class="ui-col ui-col-55 ui-flex-pack-start img left-padding ui-border-b li subtitle">{{log |getData}}</li>
							<li class="ui-col ui-col-35 ui-border-b li">
							<button class="button-type" v-on:click="showName(log)" >设置提示名称</button><button class="button-type" v-on:click="clickState(log)"  >{{log.msgState=='0'?'开启':'关闭'}}</button>
							</li>
		    		</ul>
        	</div>
        </div>    
				<div class="alert" v-show="alert3" >
					<div class="dialog" >
						<div style="text-align:center;color:red;" >{{msg}} </div>
					</div>
			</div>
			<div class="alert" v-show="alert1" >
				<div class="dialog" >
					<div><input class="input-type" v-model="logName" placeholder="报警名称" /> </div>
					<div style="padding: 20px;padding-bottom: 0; text-align: center;" ><button class="btn-type pointer" v-on:click="setName()" >确定</button><button class="btn-type btn-close pointer" v-on:click="close(1)" >取消</button></div>
				</div>
		</div>
		 </div>
  </div>

</template>

<script>
  import headlink from '@/components/common/headlink'

  export default {
    name: 'info',
    data () {
      return {
        uId:"",
        eqId:"",
        logList:[],
				msg:"",
				alert3:false,
				alert1:false,
				logName:"",
				log:{},
				msgTime:""
      }
    },
		filters:{
			getData:function(log){
				var word1 = log.msgContent.substring(0,1);
				var word2 = log.msgContent.substring(1,2);
				var str = "";
				if(word2 == "0"){
					str = "断开";
				}
				if(word2 == "1"){
					str = "连通";
				}
				return "端口：端口"+word1+str;
			}
		},
    methods:{
			setTime:function(){
				var self = this;
				var msgTime = parseInt(this.msgTime);
				if(!(msgTime>=0&&msgTime <100)){
					self.msg = "请输入数字00-99";
					self.alert3 = true;
						window.setTimeout(function(){
						self.alert3 = false;
					},3000)
					return;
				}
				const history = window.sessionStorage;
				var uid = history.getItem("user");
				this.eqId = this.$route.params.eqId;
				this.alert1 = false;
				this.$http.post('/ZYun/HttpService.do', {
					"serviceCode":"1013",
					"uId":uid,
					"eqId":this.eqId,
					"msgId":this.logList[0].msgId,
					"msgTime":this.msgTime
				})
					.then((response) => {
						if(response.data.respCode=="0000"){
							self.msg = "操作成功";
							self.alert3 = true;
								window.setTimeout(function(){
								self.alert3 = false;
							},3000);
							this.log.msgName = this.logName;
							console.log(response)
						}else{
							self.msg = response.data.respMsg;
							self.alert3 = true;
								window.setTimeout(function(){
								self.alert3 = false;
							},3000);
							console.log(response);
						}
					})
					.catch((response) =>{
						console.log(response);
					});
			},
			close:function(flag){
				if(flag == 1){
					this.alert1 = false;
				}
			},
			setName:function(){
				if(this.logName == ""){
					return;
				}
				var self = this;
				const history = window.sessionStorage;
				var uid = history.getItem("user");
				this.eqId = this.$route.params.eqId;
				this.alert1 = false;
				this.$http.post('/ZYun/HttpService.do', {
					"serviceCode":"1013",
					"uId":uid,
					"eqId":this.eqId,
					"msgId":this.log.msgId,
					"msgName":this.logName
				})
					.then((response) => {
						if(response.data.respCode=="0000"){
							
							self.msg = "操作成功";
							self.alert3 = true;
								window.setTimeout(function(){
								self.alert3 = false;
							},3000);
							this.log.msgName = this.logName;
							this.logName = "";
							console.log(response)
						}else{
							self.msg = response.data.respMsg;
							self.alert3 = true;
								window.setTimeout(function(){
								self.alert3 = false;
							},3000);
							console.log(response);
						}
					})
					.catch((response) =>{
						console.log(response);
					});
			},
			showName:function(obj){
				this.alert1 = true;
				this.log = obj;
			},
			clickState:function(obj){
				var state = "";
				if(obj.msgState == '0'){
					state = "1";
				}
				if(obj.msgState == '1'){
					state = "0";
				}
				var self = this;
				const history = window.sessionStorage;
				var uid = history.getItem("user");
				this.eqId = this.$route.params.eqId;
				this.$http.post('/ZYun/HttpService.do', {
					"serviceCode":"1013",
					"uId":uid,
					"eqId":this.eqId,
					"msgId":obj.msgId,
					"msgState":state
				})
					.then((response) => {
						if(response.data.respCode=="0000"){
							self.msg = "操作成功";
							self.alert3 = true;
								window.setTimeout(function(){
								self.alert3 = false;
							},3000);
							obj.msgState = state;
							console.log(response)
						}else{
							self.msg = response.data.respMsg;
							self.alert3 = true;
								window.setTimeout(function(){
								self.alert3 = false;
							},3000);
							console.log(response);
						}
					})
					.catch((response) =>{
						console.log(response);
					});
			}
    },
    mounted: function () {
      const history = window.sessionStorage;
    var uid = history.getItem("user");
    this.eqId = this.$route.params.eqId;
    this.$http.post('/ZYun/HttpService.do', {
      "serviceCode":"1014",
      "uId":uid,
      "eqId":this.eqId
    })
      .then((response) => {
        if(response.data.respCode=="0000"){
					this.logList = response.data.msgList;
          console.log(response)
        }else{
          console.log(response);
        }
      })
      .catch((response) =>{
        console.log(response);
      });
    },
    components: {
      headlink:headlink
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../static/css/index.css" >
</style>



// WEBPACK FOOTER //
// src/components/devicemanage/port1.vue